enum LanguageType {
    zh_CN = "zh-CN",
    zh = "zh",
    en = "en",
    en_GB = "en-GB",
    en_US = "em-US"
}

export default LanguageType